// @mui
import { ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import Iconify from '../iconify';

import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useState } from 'react';

const reorder = (list: any, startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

interface OptionsOrderingTableProps {
  reorderHandler: (options: any) => void;
  options: any;
}

export default function OptionsOrderingTable({
  options,
  reorderHandler,
}: OptionsOrderingTableProps) {
  const [state, setState] = useState({ options });
  function onDragEnd(result: any) {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const options = reorder(
      state.options,
      result.source.index,
      result.destination.index
    ).map((option: any, index) => {
      option.option_order = index;
      return option;
    });

    reorderHandler(options);
    setState({ options });
  }
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId='droppable'>
        {(provided: any) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {state.options.map((item: any, index: number) => (
              <Draggable
                key={item.option_id}
                draggableId={item.option_id.toString()}
                index={index}
              >
                {(provided: any) => (
                  <ListItem
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <ListItemAvatar>
                      <Iconify icon='eva:flip-outline' />
                    </ListItemAvatar>
                    <ListItemText primary={item.title_en} secondary='' />
                  </ListItem>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
